import Vue from 'vue';
import get from 'lodash/get';
import Level from '@/config/levels.json';
import Store from '@/store';

const isProhibited = (levelNumber, feature) => {
  const isAllowed = Level[levelNumber][feature];
  return isAllowed === undefined;
};

Vue.directive('level', {
  inserted(element, binding, virtualNode) {
    const levelNumber = get(
      Store,
      'state.Concierge.currentConcierge.conciergeLevel',
      0
    );
    const featureName = binding.value;
    if (isProhibited(levelNumber, featureName)) {
      virtualNode.elm.parentElement.removeChild(virtualNode.elm);
    }
  }
});

export default {
  canAccess: featureName => {
    const levelNumber = get(
      Store,
      'state.Concierge.currentConcierge.conciergeLevel',
      0
    );

    return !isProhibited(levelNumber, featureName);
  }
};
